<app-navbar></app-navbar>
<section class="questions-page py-4 py-xl-5 main-section-body-content">
    <div class="container">
        <div class="questions-header mb-4">
            <h2>Questions Library</h2>
            <p>Browse, search, and preview all available questions.</p>
        </div>
        <div class="questions-card">
            <div class="table-toolbar">
                <mat-form-field appearance="outline">
                    <mat-label>Search questions</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Filter by title, level, or timeline" #input>
                </mat-form-field>
            </div>
            <div class="table-box">
                <div class="mat-elevation-z0 table-responisve list-questions-section">
                    <table mat-table [dataSource]="questionsArray" matSort>
                
                        <!-- Community Name Column -->
                        <ng-container matColumnDef="questionTitle">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Question Title </th>
                            <td mat-cell *matCellDef="let row"> {{row.questionTitle}} </td>
                        </ng-container>
                
                        <!-- Participants number Column -->
                        <ng-container matColumnDef="grade">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Grade </th>
                            <td mat-cell *matCellDef="let row"> {{row.grade}} </td>
                        </ng-container>
                
                        <!-- Community visibility Column -->
                        <ng-container matColumnDef="timeline">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Question Timeline</th>
                            <td mat-cell *matCellDef="let row"> {{row.timeline}} Mins</td>
                        </ng-container>
                
                        <!-- Button Column -->
                        <ng-container matColumnDef="edit">
                            <th mat-header-cell *matHeaderCellDef> Preview </th>
                            <td mat-cell *matCellDef="let row">
                                <button class="preview-btn" type="button">Open</button>
                            </td>
                        </ng-container>
                
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                            (click)="openQuestionPreview(row.typeId, row.questionId)"></tr>
                
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>
